import { render, staticRenderFns } from "./InsuranceNotCover.vue?vue&type=template&id=436e6e7e&scoped=true&"
import script from "./InsuranceNotCover.vue?vue&type=script&lang=js&"
export * from "./InsuranceNotCover.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceNotCover.vue?vue&type=style&index=0&id=436e6e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e6e7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('436e6e7e')) {
      api.createRecord('436e6e7e', component.options)
    } else {
      api.reload('436e6e7e', component.options)
    }
    module.hot.accept("./InsuranceNotCover.vue?vue&type=template&id=436e6e7e&scoped=true&", function () {
      api.rerender('436e6e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/InsuranceNotCover.vue"
export default component.exports